// extracted by mini-css-extract-plugin
export default {"sourceRow":"RuleCard_sourceRow__C96SP","sourceText":"RuleCard_sourceText__Z0Io2","deleteText":"RuleCard_deleteText__ni797","enableDisableLabel":"RuleCard_enableDisableLabel__hUzks"};